import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import PasswordReset from '../../pages/PasswordReset'
import { executeRecaptcha } from '../../actions/secureForm'
import { submitPasswordReset } from '../../actions/passwordReset'
import { getSiteKey } from '../../selectors/initialization'
import {
  getError,
  getProcessed,
  getDisabledForm
} from '../../selectors/formCommon'

export const mapStateToProps = createSelector(
  [getSiteKey, getProcessed, getError, getDisabledForm],
  (siteKey, processed, error, disabledForm) => ({
    siteKey,
    processed,
    error,
    disabledForm
  })
)

export const mapDispatchToProps = dispatch => ({
  onSubmit: ({ email, recaptchaResponse }) =>
    dispatch(submitPasswordReset({ email, recaptchaResponse })),
  onExecuteRecaptcha: () => dispatch(executeRecaptcha())
})

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset)
